export enum ToastType {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

export class ToastModel {
  Titulo: string;
  Mensagem: string;
  Tipo: ToastType;

  constructor(Titulo: string, Mensagem: string, Tipo: ToastType) {
      this.Titulo = Titulo;
      this.Mensagem = Mensagem;
      this.Tipo = Tipo;
  }
}
